import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { InlineFilters, ListPageHeader, ListSearchForm, ResultsCard, SearchToolbar } from "../../common/DataList";
import Axios from "axios";
import { api_url } from "../../../config";
import useStore from "../../../context/useStore";
import tools from "../../../helpers/tools";
import dataService from "../../../helpers/dataService";

var strTimeout = null;

const COUNT_LABELS = {
  none: "Aucun allocataire temporaire trouvé",
  one: "allocataire temporaire trouvé",
  many: "allocataires temporaires trouvés",
};

// Critères sous la recherche libre, toujours visibles (mêmes clés que l'écran
// historique : user.noEmail, user.isPublicCaf).
export const FILTRES_TEMPORAIRES = [
  { name: "noEmail", label: "Ne possédant aucun email", type: "checkbox" },
  {
    name: "isPublicCaf",
    label: "Public CAF",
    type: "checkbox",
    hint: "Uniquement les moins de 18 ans et les 25 ans et plus",
  },
];

const RecipientTempList = (props) => {
  const [recipients, setRecipients] = useState([]);
  const [state, dispatch] = useStore();
  const constants = state.constants.items;
  const constantesChargees = !!constants.RECIPIENT_ORIGINS;
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(false);
  var searchState = tools.getState("RecipientTempList", null);
  const [search, setSearch] = useState(
    searchState
      ? JSON.parse(searchState.search)
      : {
          user: {
            searchString: "",
            noEmail: false,
            isPublicCaf: false,
          },
          page: 1,
          nbItemsByPage: 25,
        }
  );
  const [nbPages, setNbPages] = useState(1);
  const [nbResults, setNbResults] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);

  function searchRecipients(overrideFilter) {
    setErrors({});
    setHasSearched(true);
    const realSearch = overrideFilter || search;
    tools.saveState("RecipientTempList", "search", JSON.stringify(realSearch));
    setIsLoading(true);
    dataService.post(
      "recipients_dsp/search",
      realSearch,
      (data) => {
        setRecipients(data.data);
        setNbPages(Math.ceil(parseInt(data.count) / realSearch.nbItemsByPage));
        setIsLoading(false);
        setNbResults(data.count);
      },
      setErrors,
      () => setIsLoading(false)
    );
  }
  function updateSearch(e) {
    var value = e.target.value;
    var su = { ...search };

    su.user[e.target.name] = value;

    setSearch(su);
  }

  function changePage(i) {
    const newSearch = { ...search, page: i };
    setSearch(newSearch);
    searchRecipients(newSearch);
  }
  function changeNbItemsByPage(i) {
    const newSearch = { ...search, nbItemsByPage: i };
    setSearch(newSearch);
    searchRecipients(newSearch);
  }

  // Case à cocher des filtres : même mise à jour que l'écran historique.
  const updateCheckbox = (e) =>
    setSearch({
      ...search,
      user: { ...search.user, [e.target.name]: e.target.checked },
    });

  return (
    <div className="container-fluid px-5 my-5 list-page">
      <ListPageHeader title="Allocataires temporaires" />
      <ListSearchForm onSubmit={() => searchRecipients()} aria-label="Recherche d'allocataires temporaires">
        <SearchToolbar
          id="searchString"
          name="searchString"
          value={search.user.searchString}
          onChange={updateSearch}
          placeholder="NIR, matricule, nom, prénom, téléphone, email…"
          isLoading={isLoading}
          inlineFilters={
            <InlineFilters
              definitions={FILTRES_TEMPORAIRES}
              filters={search.user}
              onChange={updateCheckbox}
              onSet={() => {}}
            />
          }
        />
      </ListSearchForm>
      <ResultsCard
        caption="Liste des allocataires temporaires"
        rows={constantesChargees ? recipients : []}
        count={nbResults}
        countLabels={COUNT_LABELS}
        hasSearched={hasSearched}
        isLoading={isLoading || !constantesChargees}
        error={errors && errors.other}
        page={search.page}
        nbPages={nbPages}
        nbItemsByPage={search.nbItemsByPage}
        onChangePage={changePage}
        onChangeNbItemsByPage={changeNbItemsByPage}
        itemLabel="allocataires temporaires"
        fields={[
          {
            name: "Nom",
            exportPath: "name",
            path: "*",
            render: (elem) => (
              <Link to={"/recipients-temp/" + elem.id} className="recipient-name">
                {tools.getFullname(elem)}
              </Link>
            ),
          },
          {
            name: "NIR",
            path: "nir",
          },
          {
            name: "Age",
            exportPath: "age",
            path: "*",
            render: (elem) =>
              elem && elem.birthdate
                ? tools.getAgeFromBirthdate(elem.birthdate)
                : "",
          },
          {
            name: "Matr.",
            path: "CAFId",
          },
          {
            name: "Email",
            path: "email",
          },
          {
            name: "Tél",
            path: "phone",
          },
          {
            name: "Lieu",
            path: "location",
            render: (elem) =>
              elem && elem.postalCode
                ? elem.postalCode + " " + elem.name
                : "",
          },
          {
            name: "Origine",
            path: "origin",
            render: (elem) =>
              elem &&
              constants.RECIPIENT_ORIGINS.find((m) => m.id == elem)
                .name,
          },
          {
            name: "Droits",
            path: "rights",
            render: (elem) =>
              elem &&
              constants.RSA_TYPES.find((m) => m.id == elem.type) &&
              constants.RSA_TYPES.find((m) => m.id == elem.type)
                .name,
          },
          {
            name: "Voir",
            path: "id",
            render: (elem) => (
              <Link
                to={"/recipients-temp/" + elem}
                className="btn btn-primary w-100 btn-sm d-flex align-items-center justify-content-center"
              >
                <i className="fa fa-eye"></i>
              </Link>
            ),
          },
        ]}
      />
    </div>
  );
};

export default RecipientTempList;
